export default __webpack_public_path__ + "static/media/ic_star_half_48px.e0eab98c.svg";